var map = {
	"./ada-payment-icon.svg": 45,
	"./ada.png": 120,
	"./adapay-logo-white.svg": 46,
	"./adapay-logo.svg": 66,
	"./adapay.svg": 67,
	"./bg.png": 121,
	"./btc.png": 122,
	"./confirmed.svg": 68,
	"./copy-icon.png": 69,
	"./copy-icon.svg": 47,
	"./coti-logo.png": 57,
	"./curved-bg-payment.svg": 70,
	"./expired.svg": 71,
	"./header-background.png": 123,
	"./payment-card-header-bg.svg": 72,
	"./payment_sent.svg": 73,
	"./pending.svg": 74,
	"./save-the-children.svg": 75,
	"./shield.svg": 76,
	"./success-icon.png": 124,
	"./timer-icon.svg": 48,
	"./vector-copy-icon.png": 125,
	"./warning-red.png": 126,
	"./warning.png": 127
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65;